import React from 'react'

const SupportMessage = () => (
  <div className="mt-8 text-center pb-10 md:pb-0">
    <p className="text-sm text-gray-600">
      Si tiene inconvenientes, comuníquese con la mesa de ayuda al correo{' '}
      <a href="mailto:mesadeayuda@gobiernodigital.gob.pe" className="text-blue-600 hover:underline">
        mesadeayuda@gobiernodigital.gob.pe
      </a>
    </p>
  </div>
)

export default SupportMessage
